import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Title,
  Values,
  Estimate,
  BtnGroup,
  Btn,
  TextInput,
  Option,
} from '../survey.css';

class ValueEstimate extends Component {
  static propTypes = {
    userEmail: PropTypes.string,
    setUserEmail: PropTypes.func.isRequired,
    nextStep: PropTypes.number.isRequired,
    goFwd: PropTypes.func.isRequired,
  };

  render() {
    const { userEmail, setUserEmail } = this.props;

    return (
      <Card>
        <Title>Value Estimate</Title>
        <Values>
          <Estimate>
            <div className="partner">Good</div>
            <div className="price">$500,000</div>
          </Estimate>
          <Estimate>
            <div className="partner">Better</div>
            <div className="price">
              {userEmail === null ? (
                <span className="signUp">SIGN UP</span>
              ) : (
                <span>400$</span>
              )}
            </div>
          </Estimate>
          <Estimate>
            <div className="partner">Best</div>
            <div className="price">
              {userEmail === null ? (
                <span className="signUp">SIGN UP</span>
              ) : (
                <span>400$</span>
              )}
            </div>
          </Estimate>
        </Values>
        {userEmail === null && (
          <BtnGroup>
            <p>Enter your email for more partner offers</p>
            <TextInput type="email" required placeholder="Enter Your Email" />
            <Btn onClick={() => setUserEmail()}>Sign Up</Btn>
            <Option skip small>
              No Thanks
            </Option>
          </BtnGroup>
        )}
        <Title small>Partners In Your Area</Title>
      </Card>
    );
  }
}

export default ValueEstimate;
